import React from 'react';
import * as Api from "../../utils/api";
import CourseItem from "./CourseItem";
const GLOBAL_IMAGE_URL = Api.imageGlobalUrl;
export default class HomeCourseList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { }
    }
    render(){
        const _this = this;
        let courseList = _this.props.courseList;
        return (
            <div className="home-module module-margin">
                <div className="module-title">
                    {
                        _this.props.moduleTitle
                        ? <img src={ GLOBAL_IMAGE_URL + _this.props.moduleTitle }/> 
                        : null
                    }                       
                </div>
                <div className="module-linebg">
                </div>
                <div className="module-course">
                    {
                        courseList.length > 0
                        ?   courseList.map((item,index) =>{
                                return (
                                    <CourseItem 
                                        type={ _this.props.type }
                                        key={ item.courseID } 
                                        item={ item } 
                                        index={ index } 
                                        lineLimit = { courseList.length }
                                        courseListHandler={ _this.courseListHandler.bind(_this) }>
                                    </CourseItem>
                                )
                            })
                        : null
                    }
                </div>
            </div> 
        );
    }
    courseListHandler(item) {
        const _this = this;
        _this.props.courseDetailHandler(item);
    }
}
